<template>
<!-- ====================== 페이지내 내용 ====================== -->
    <div>
        <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >
        <v-toolbar-title >대시보드</v-toolbar-title>
        <v-spacer/>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= ""
            >mdi-information-variant</v-icon>
        </v-btn>
    </template>
    데시보드 관련 설명
    </v-tooltip>
    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <form
            class="pa-4">
            <v-row>
                <v-col>
                    <v-select
                    v-model="projectGroup"
                    :items="items"
                    label="프로젝트그룹 선택"
                    item-text="project_group"
                    item-value="project_group_flag"
                    filled
                    outlined
                    dense
                    hide-details
                    ></v-select>
                </v-col>
                <v-col>
                    <v-select
                    v-model="languageSelect"
                    :items="items2"
                    label="언어권 선택"
                    item-text="project_group"
                    item-value="project_group_flag"
                    filled
                    outlined
                    dense
                    hide-details
                    ></v-select>
                </v-col>
                <v-col>
                </v-col>
            </v-row>
            <v-radio-group
            v-model="dayOfMonth"
            row
            
            >
            <v-radio
                label="일별"
                value="date"
            ></v-radio>
            <v-radio
                label="월별"
                value="month"
            ></v-radio>
            </v-radio-group>
            <v-radio-group
            v-if="dayOfMonth == 'date'"
            v-model="days"
            row
            >
            <v-radio
                label="최근 7일"
                :value="7"
            ></v-radio>
            <v-radio
                label="최근 30일"
                :value="30"
            ></v-radio>
            <v-radio
                label="최근 90일"
                :value="90"
            ></v-radio>
            <v-radio
                label="직접 입력"
                value="custom"
            ></v-radio>
            </v-radio-group>
            <v-radio-group
                v-if="dayOfMonth == 'month'"
                v-model="months"
                row
            >
            <v-radio
                label="12개월"
                :value="12"
            ></v-radio>
            <v-radio
                label="24개월"
                :value="24"
            ></v-radio>
            <v-radio
                label="36개월"
                :value="36"
            ></v-radio>
            <v-radio
                label="직접 입력"
                value="custom"
            ></v-radio>
            </v-radio-group>
            <v-row v-if="dayOfMonth == 'date'">
                <v-col v-if="dayOfMonth == 'date'">
                    <v-menu
                        v-if="dayOfMonth == 'date'"
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="시작일 선택"
                            :disabled="days != 'custom'"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date"
                        :type="'date'"
                        no-title
                        scrollable
                        :max="date2"
                        @click:date="$refs.menu.save(date)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col v-if="dayOfMonth == 'date'">
                    <v-menu
                        v-if="dayOfMonth == 'date'"
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date2"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date2"
                            :disabled="days != 'custom'"
                            label="종료일 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date2"
                        :type="'date'"
                        no-title
                        scrollable
                        :max="today"
                        :min="date"
                        @click:date="$refs.menu2.save(date2)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                </v-col>
            </v-row>
            <v-row v-if="dayOfMonth == 'month'">
                <v-col v-if="dayOfMonth == 'month'">
                    <v-menu
                        v-if="dayOfMonth == 'month'"
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :return-value.sync="date3"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date3"
                            :disabled="months != 'custom'"
                            label="시작월 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date3"
                        :type="'month'"
                        no-title
                        scrollable
                        :max="date4"
                        @click:month="$refs.menu3.save(date3)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col v-if="dayOfMonth == 'month'">
                    <v-menu
                        v-if="dayOfMonth == 'month'"
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        :return-value.sync="date4"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date4"
                            :disabled="months != 'custom'"
                            label="종료월 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date4"
                        :type="'month'"
                        no-title
                        scrollable
                        :max="today"
                        :min="date3"
                        @click:date="$refs.menu4.save(date4)"
                        @click:month="$refs.menu4.save(date4)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1">
                    <v-btn
                    class="mr-4"
                    color="blue"
                    @click="submit"
                    :disabled="tempInfo[0]?false:true"
                    block
                    >
                    검색
                    </v-btn>
                </v-col>
            </v-row>
        </form>
    </v-card>
        <div class="py-3"></div>
    <v-card
        class="mx-auto pb-1"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
        dense
    >
        <v-toolbar-title>{{ resDayOfMonth == 'date'?'일별':resDayOfMonth == 'month'?'월별':'차트'}}</v-toolbar-title>
    </v-toolbar>
        <v-card class="mb-4 mt-4 mx-4" outlined>
            <v-card-title>금액</v-card-title>
            <v-card-subtitle class="">
                {{ resDayOfMonth == 'date'?'매 일간 결제금액':resDayOfMonth == 'month'?'매 월간 결제금액':'결제금액'}}
            </v-card-subtitle>
            <div
                v-if="dataFlag == 'underRequest'"
                class="d-flex justify-center pa-6" >
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
            </div>
            <div
            v-if="dataFlag == 'dataExdate' || dataFlag == 'dataExmonth'"
            class="mx-3 mb-2">
                <line-chart :chart-data="chartdataCost" :options="options"/>
            </div>
        </v-card>
        <v-card class="mb-4 mt-4 mx-4" outlined >
            <v-card-title>건수</v-card-title>
            <v-card-subtitle class="">
                {{ resDayOfMonth == 'date'?'매 일간 결제건수':resDayOfMonth == 'month'?'매 월간 결제건수':'결제건수'}}
            </v-card-subtitle>
            <div
                v-if="dataFlag == 'underRequest'"
                class="d-flex justify-center pa-6" >
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
            </div>
            <div
            v-if="dataFlag == 'dataExdate' || dataFlag == 'dataExmonth'"
            class="mx-3 mb-2">
                <line-chart :chart-data="chartdataCount" :options="options2"/>
            </div>
        </v-card>
    </v-card>
        <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
        dense
    >
        <v-toolbar-title>{{ resDayOfMonth == 'date'?'일별 데이터 테이블':resDayOfMonth == 'month'?'월별 데이터테이블':'데이터 테이블'}}</v-toolbar-title>
        <v-spacer/>
    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <v-data-table
            :headers="headers"
            :items="statisticsData"
            :single-select="false"
            item-key="basePeriod"
            :search="search"
            class="elevation-1"
            :loading="dataFlag == 'underRequest'"
            loading-text="데이터를 가져오는 중입니다. 잠시만 기다려 주세요. 30초정도 소요 될 수 있습니다."
            hide-default-footer
            :items-per-page="-1"
        >
            <template v-slot:item.androidSumCount="{ item }">
                {{ item.androidSumCount.toLocaleString() }}
            </template>
            <template v-slot:item.androidSumCost="{ item }">
                {{ '₩' + item.androidSumCost.toLocaleString() }}
            </template>
            <template v-slot:item.iosSumCount="{ item }">
                {{ item.iosSumCount.toLocaleString() }}
            </template>
            <template v-slot:item.iosSumCost="{ item }">
                {{ '₩' + item.iosSumCost.toLocaleString() }}
            </template>
            <template v-slot:item.totalSumCount="{ item }">
                {{ item.totalSumCount.toLocaleString() }}
            </template>
            <template v-slot:item.totalSumCost="{ item }">
                {{ '₩' + item.totalSumCost.toLocaleString() }}
            </template>
        </v-data-table>
    </v-card>

    <div class="py-3"></div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
import LineChart from './charts/LineChart'
export default {
    name: 'UserList',
    components: {
      LineChart,
    },
    data: () => ({
        months:24,
        yesterday:moment().subtract(1,'d').format('yyyy-MM-DD'),
        request:false,
        billingDashData:{'dashData':[],'dayOrMonth':[]},
        languageSelect:'6',
        projectGroup:'4',
        dayOfMonth:'date',
        switch1:false,
        switch2:false,
        switch3:false,
        switch4:false,
        dtatatabledata:[],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
            callbacks: {
                    label: function(tooltipItem, data) {
                        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        if(parseInt(value) >= 1000){
                                return '₩' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                } else {
                                return '₩' + value;
                                }
                    }
            } // end callbacks:
        }, //end tooltips                
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true,
                        callback: function(value, index, values) {
                            if(parseInt(value) >= 1000){
                               return '₩' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            } else {
                               return '₩' + value;
                            }
                       }                            
                    }
                }]
            }
        },
        options2: {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
            callbacks: {
                    label: function(tooltipItem, data) {
                        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        if(parseInt(value) >= 1000){
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '건';
                                } else {
                                return value + '건';
                                }
                    }
            } 
        },   
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true,
                        callback: function(value, index, values) {
                            if(parseInt(value) >= 1000){
                               return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '건';
                            } else {
                               return value + '건';
                            }
                       }                            
                    }
                }]
            }
        },
        chartdata2: {
            hoverBackgroundColor: "red",
            hoverBorderWidth: 10,
            labels: ["Green", "Red", "Blue", "Blue2", "Blue3", "Blue4", "Blue5", "Blue6"],
            datasets: [
            {
                label: "Data One",
                backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#00D8FF", "#0472FF", "#6358FF", "#9648FF", "#2958FF"],
                data: [1, 10, 5, 9, 3, 6, 21, 12]
            }
            ]
        },
        datacollection: {},
        items: [
            {'project_group':'Day7', 'project_group_flag':'4'},
            {'project_group':'Publishing', 'project_group_flag':'1'},
        ],
        items2: [
            {'project_group':'전체', 'project_group_flag':'6'},
            {'project_group':'한국', 'project_group_flag':'1'},
            {'project_group':'일본', 'project_group_flag':'3'},
            {'project_group':'대만', 'project_group_flag':'4'},
            {'project_group':'중국', 'project_group_flag':'5'},
            {'project_group':'영어', 'project_group_flag':'2'},
        ],
        search:'',
        today: moment().format('YYYY-MM-DD'),
        subDate:'',
        tempInfo:[],
        app_ad:'front',
        days:30,
        menu: false,
        menu2:false,
        date:moment().subtract(29,'d').format('yyyy-MM-DD'),
        date2:moment().format('yyyy-MM-DD'),
        menu3: false,
        menu4:false,
        date3:moment().subtract(23,'M').format('yyyy-MM'),
        date4:moment().format('yyyy-MM'),
        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        viewCount:'노출수',
        clickCount:'클릭수',
        downCount:'다운수',
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록
        event_history_all:[           
        ]
    }),

    created()
    {
        this.dateCaculate()
        this.submit()
    },

    methods:{
        ...mapActions([
            'GET_LOG_TODAY',
            'GET_LOG',
            'GET_BILLING_DASH_DATA',
        ]),
        submit(){
            console.log('결제 데이터 가져오기 실행됨')
            // 데이터를 체우기 전에 비워준다. 차트 컨포넌트에서 에러가 나기 때문에 이러한 데이터를 넣어준다.
            this.billingDashData = {'dashData':[],'dayOrMonth':[]}
            this.request = true
            this.getBillingDashData()
        },
        async getBillingDashData () {
            // 여기서 요청에 들어갈 데이터들을 선언하여 주어야 한다.
            const project_group = this.projectGroup
            const selected_language = this.languageSelect
            // 월로 정해진 경우, 요청에 넣어서 보내주기 전에  가공을 한번 해야 한다. 
            const temp_info = this.tempInfo
            const day_or_month = this.dayOfMonth
            this.billingDashData = await this.GET_BILLING_DASH_DATA({project_group,selected_language,day_or_month,temp_info,})
            console.log(this.billingDashData)

            // 들어가는 코드는 데이터테이블에 해당되는 데이터를 대입시켜주는 코드라 들어가야 한다.

        },
        dateCaculate () {
                if(this.date != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                while ( this.subDate <= moment(this.date2)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
            }
            this.subDate = ''
        },
        monthCaculate () {
                if(this.date3 != ''){
                this.tempInfo = []
                this.subDate = moment(this.date3)
                while ( this.subDate <= moment(this.date4)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM'))
                    this.subDate = this.subDate.add(1,'M')
                }
            }
            this.subDate = ''
        },
    },
    computed: {
        androidSumCountT () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + parseInt(c.androidSumCount)
            }, 0).toLocaleString()})`:''
        },
        androidSumCostT () {
            return this.statisticsData[0]?`(₩${this.statisticsData.reduce((p, c, i, a) => {
                return p + parseInt(c.androidSumCost)
            }, 0).toLocaleString()})`:''
        },
        iosSumCountT () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + parseInt(c.iosSumCount)
            }, 0).toLocaleString()})`:''
        },
        iosSumCostT () {
            return this.statisticsData[0]?`(₩${this.statisticsData.reduce((p, c, i, a) => {
                return p + parseInt(c.iosSumCost)
            }, 0).toLocaleString()})`:''
        },
        totalSumCountT () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + parseInt(c.totalSumCount)
            }, 0).toLocaleString()})`:''
        },
        totalSumCostT () {
            return this.statisticsData[0]?`(₩${this.statisticsData.reduce((p, c, i, a) => {
                return p + parseInt(c.totalSumCost)
            }, 0).toLocaleString()})`:''
        },
        headers () {
            return [            
            { text: 'DATE', value: 'basePeriod', sortable: false },
            { text: `Android 건수 ${this.androidSumCountT}`, value: 'androidSumCount', sortable: true  },
            { text: `Android 금액 ${this.androidSumCostT}`, value: 'androidSumCost', sortable: true },
            { text: `IOS 건수 ${this.iosSumCountT}`, value: 'iosSumCount', sortable: true },
            { text: `IOS 금액 ${this.iosSumCostT}`, value: 'iosSumCost', sortable: true },
            { text: `전체건수 ${this.totalSumCountT}`, value: 'totalSumCount', sortable: true },
            { text: `전체금액 ${this.totalSumCostT}`, value: 'totalSumCost', sortable: true },
        ]
        },
        dataFlag () {
            return this.billingDashData.dashData[0]?this.resDayOfMonth == 'date'?'dataExdate':'dataExmonth':this.request?'underRequest':'noRequest'
        },
        resDayOfMonth () {
            return this.billingDashData.dayOrMonth
        },
        chartdataCost () {
            return {
                labels: this.billingDashData.dashData.map((value,index,array)=> { return value.basePeriod }),
                datasets: [
                    {
                    label: '전체',
                    borderColor: '#ff6666',
                    fill: false,
                    tension: 0,
                    data: this.billingDashData.dashData.map((value,index,array)=> { return value.totalSumCost })
                    },
                    {
                    label: '안드로이드',
                    borderColor: '#66ff66',
                    fill: false,
                    tension: 0,
                    data: this.billingDashData.dashData.map((value,index,array)=> { return value.androidSumCost })
                    },
                    {
                    label: 'ios',
                    borderColor: '#66b2ff',
                    fill: false,
                    tension: 0,
                    data: this.billingDashData.dashData.map((value,index,array)=> { return value.iosSumCost })
                    },
                ]
            }
        },
        chartdataCount () {
            return {
                labels: this.billingDashData.dashData.map((value,index,array)=> { return value.basePeriod }),
                datasets: [
                    {
                    label: '전체',
                    borderColor: '#ff6666',
                    fill: false,
                    tension: 0,
                    data: this.billingDashData.dashData.map((value,index,array)=> { return value.totalSumCount })
                    },
                    {
                    label: '안드로이드',
                    borderColor: '#66ff66',
                    fill: false,
                    tension: 0,
                    data: this.billingDashData.dashData.map((value,index,array)=> { return value.androidSumCount })
                    },
                    {
                    label: 'ios',
                    borderColor: '#66b2ff',
                    fill: false,
                    tension: 0,
                    data: this.billingDashData.dashData.map((value,index,array)=> { return value.iosSumCount })
                    },
                ]
            }
        },
        statisticsData () {
            return this.billingDashData.dashData
        },

    },
    watch :{
        date: function() {
                if(this.date != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                while ( this.subDate <= moment(this.date2)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
            }
            this.subDate = ''
        },
        date2: function() {
            if(this.date2 != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                while ( this.subDate <= moment(this.date2)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
            }
            this.subDate = ''
        },
        date3: function() {
                if(this.date3 != ''){
                this.tempInfo = []
                this.subDate = moment(this.date3)
                while ( this.subDate <= moment(this.date4)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM'))
                    this.subDate = this.subDate.add(1,'M')
                }
            }
            this.subDate = ''
        },
        date4: function() {
            if(this.date4 != ''){
                this.tempInfo = []
                this.subDate = moment(this.date3)
                while ( this.subDate <= moment(this.date4)){
                    this.tempInfo.push( this.subDate.format('YYYY-MM'))
                    this.subDate = this.subDate.add(1,'M')
                }
            }
            this.subDate = ''
        },
        days: function() {
                if(this.days == 'custom') {
                    this.date =  moment().subtract(29,'d').format('yyyy-MM-DD')
                    this.date2 =  moment().format('yyyy-MM-DD')
                    this.dateCaculate()
                } else {
                    this.date =  moment().subtract(this.days - 1,'d').format('yyyy-MM-DD')
                    this.date2 =  moment().format('yyyy-MM-DD')
                    this.dateCaculate()
                }
        }, 
        months: function() {
            console.log('months watch 실행됨')
                if(this.months == 'custom') {
                    this.date3 =  moment().subtract(23,'M').format('yyyy-MM')
                    this.date4 =  moment().format('yyyy-MM')
                    this.monthCaculate()
                } else {
                    this.date3 =  moment().subtract(this.months - 1,'M').format('yyyy-MM')
                    this.date4 =  moment().format('yyyy-MM')
                    this.monthCaculate()
                }
        },
        dayOfMonth: function() {
            console.log('dayOrMonth watch 시직됨')
            if(this.dayOfMonth == 'date') {
                if (this.days == 30){
                    this.dateCaculate()
                } else {
                    this.days = 30
                }
            } else {
                if(this.months == 24){
                    this.monthCaculate()
                } else {
                    this.months = 24
                }
            }
        },
        projectBillingStatisticsData: function() {
            if(this.billingDashData.dashData[0]){
                this.request = false
            }
        },
    },
    mounted () {
    },
};
</script>
<style>
</style>
